import React from 'react';
import { useWeeklyPromo } from '../hooks/useWeeklyPromo';
interface PromoCountdownProps {
  className?: string;
  /** Compact inline variant for bars and tight cards. */
  compact?: boolean;
  /** Boxed block sized for offer cards, placed under the buy button. */
  variant?: 'default' | 'card';
}
const pad = (n: number) => String(n).padStart(2, '0');

/** Live countdown to Sunday 11:59:59 PM ET. Fixed-width digits so nothing shifts as it ticks. */
export function PromoCountdown({
  className = '',
  compact = false,
  variant = 'default'
}: PromoCountdownProps) {
  const promo = useWeeklyPromo();
  const units = [{
    label: 'Days',
    value: promo.days
  }, {
    label: 'Hrs',
    value: promo.hours
  }, {
    label: 'Min',
    value: promo.minutes
  }, {
    label: 'Sec',
    value: promo.seconds
  }];
  if (variant === 'card') {
    return <div className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 border border-white/10 bg-ink-900 px-2.5 py-1.5 text-center ${className}`} role="timer" aria-label={`${promo.headline}. ${promo.days} days, ${promo.hours} hours, ${promo.minutes} minutes left`} data-id="element-758" data-mp="175mccxwagd63">
        <span className="text-[9px] font-extrabold uppercase tracking-[0.16em] text-grit-500" aria-hidden="true" data-id="element-759" data-mp="3n3knwottm96s">
          {promo.headline}
        </span>
        <span className="text-[11px] font-bold tabular-nums text-offwhite" aria-hidden="true" data-id="element-760" data-mp="q2kkwlv3gi1">
          {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-761" data-mp="306iqgfgc1xcs" data-mpi={i}>
              {i > 0 && <span className="px-0.5 text-steel-500" data-id="element-762" data-mp="345zxvefbl4kl">:</span>}
              {pad(unit.value)}
              <span className="text-[8px] font-bold uppercase text-steel-400" data-id="element-763" data-mp="39532wyvavask">{unit.label.charAt(0)}</span>
            </React.Fragment>)}
        </span>
      </div>;
  }
  if (compact) {
    return <span className={`inline-flex items-center gap-2 ${className}`} data-id="element-764" data-mp="og6luxbkv45v">
        <span data-id="element-765" data-mp="tehw395sbgom">{promo.headline}</span>
        <span className="font-mono tabular-nums" aria-hidden="true" data-id="element-766" data-mp="tdf8pb7o7wdg">
          {pad(promo.days)}:{pad(promo.hours)}:{pad(promo.minutes)}:{pad(promo.seconds)}
        </span>
      </span>;
  }
  return <div className={className} data-id="element-767" data-mp="3uvudlel30pnq">
      <p className="text-[11px] font-extrabold uppercase tracking-[0.22em] text-grit-500" data-id="element-768" data-mp="3uyqb51t0pcbn">
        {promo.headline}
        {promo.subline && <span className="ml-2 text-offwhite" data-id="element-769" data-mp="8ow5mkxjds7f">· {promo.subline}</span>}
      </p>
      <div className="mt-3 flex items-start gap-2 sm:gap-3" role="timer" aria-label={`${promo.days} days, ${promo.hours} hours, ${promo.minutes} minutes left`} data-id="element-770" data-mp="3h58sdj85o3mo">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-771" data-mp="3qvaggb0idm1l" data-mpi={index}>
            {index > 0 && <span className="pt-2 font-display text-2xl font-bold leading-none text-steel-500 sm:text-3xl" aria-hidden="true" data-id="element-772" data-mp="3m4lqj04h8x4k">
                :
              </span>}
            <span className="flex w-14 flex-col items-center border border-white/12 bg-ink-900 py-2 sm:w-16" aria-hidden="true" data-id="element-773" data-mp="2ycen5h0c3pvn">
              <span className="font-display text-3xl font-extrabold leading-none tabular-nums text-offwhite sm:text-4xl" data-id="element-774" data-mp="18x3x5ba60t1s">
                {pad(unit.value)}
              </span>
              <span className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-steel-400" data-id="element-775" data-mp="yzg3yps7jtlq">{unit.label}</span>
            </span>
          </React.Fragment>)}
      </div>
    </div>;
}